
















































































































































import DictMixin from '@/mixins/dict-mixin';
import IndicatorServices from '@/services/indicator';
import { mixins } from 'vue-class-component';
import { Component, Watch } from 'vue-property-decorator';
import Idf4 from './indicator-form-tab4.vue';
import LogDetail from '../../../platform/pages/syslog/detail-drawer.vue';
import OpsLogServices from '@/services/opslog';
import MenuMixin from '@/mixins/menu-mixin';
@Component({
  components: { Idf4, LogDetail }
})
export default class DictDetail extends mixins(DictMixin, MenuMixin) {
  indSrv = new IndicatorServices();

  id: any = 0;
  info: any = {
    cronExpression: '0 0 2 * * ?',
    jobMode: 0,
    jobConfig: {
      rate: 0,
      runDateFormat: '',
      runDateStr: ''
    },
    indChangeAlertSetting: {
      chgAlertMode: 0,
      chgAlertSettings: [
        {
          alertEvent: 0,
          alertLevel: 0,
          intervalVal1: 60,
          intervalVal2: 90
        },
        {
          alertEvent: 0,
          alertLevel: 1,
          intervalVal1: 40,
          intervalVal2: 60
        },
        {
          alertEvent: 0,
          alertLevel: 2,
          intervalVal1: 0,
          intervalVal2: 40
        }
      ]
    }
  };

  created() {
    this.id = this.$route.query.id;
  }

  @Watch('$route')
  onRouteChange() {
    this.id = this.$route.query.id;
    this.onIdChange();
  }

  @Watch('id')
  async onIdChange() {
    if (!this.id || this.$route.path != '/decision/indicator/detail') return false;
    this.spinning = true;
    this.info = await this.indSrv.getInfo(this.id);
    this.spinning = false;
    this.info.indChangeAlertSetting = JSON.parse(this.info.indChangeAlertSetting);
    this.info.jobConfig = JSON.parse(this.info.jobConfig);
    this.info.indDefinition = JSON.parse(this.info.indDefinition);
    this.packDefText();
    this.getLogs();
  }

  definitionText: string = '';
  packDefText() {
    if (!this.DICT_AGG_FUNC) {
      setTimeout(() => this.packDefText(), 100);
      return false;
    }
    let def = this.info.indDefinition;
    let text: string = '';
    if (this.info.indType == '2') {
      console.log(def);
      text += def.isBracketLeft === 1 ? '(' : '';
      if (def.sourceParamName) {
        text += `[参数/${def.sourceParamName}]`;
      } else {
        text += `[指标/${def.sourceIndName}]`;
      }
      def.indJoin.forEach((v: any, k: number) => {
        let operator = this.DICT_VALUE('DICT_IND_OPERATOR', v.joinOperator);
        text += `${operator}`;
        text += v.isBracketLeft === 1 ? '(' : '';
        if (v.paramName) {
          text += `[参数/${v.paramName}]`;
        } else {
          text += `[指标/${v.indName}]`;
        }
        text += v.isBracketRight === 1 ? ')' : '';
      });
    } else {
      text = `[${def.mesFieldName}]在`;
      def.indSubs.forEach((v: any, k: number) => {
        if (k > 0) text += '且';
        let label = v.refDimType === 'DIM' ? v.refDimFieldValue : v.refDimFieldName;
        text += `[${v.dimFieldName}]维度上为[${label}]`;
      });
      let agg = this.DICT_VALUE('DICT_AGG_FUNC', def.aggOperator);
      text += `时求[${agg}]`;
    }
    this.definitionText = text;
  }

  columns = [
    { title: '变更时间', dataIndex: 'createTime' },
    { title: '变更人', dataIndex: 'createUser' },
    { title: '变更备注', dataIndex: 'opsComment' },
    {
      title: '操作',
      dataIndex: 'action',
      scopedSlots: {
        customRender: 'action'
      }
    }
  ];
  logVisible: boolean = false;
  logDetail: any = {};
  logSrv = new OpsLogServices();
  logList = [];
  async getLogs() {
    this.logList = await this.logSrv.getList({ opsTargetType_eq: 'indicator', opsTargetCode_eq: this.info.indCode });
  }
  openLogDetail(record: any) {
    this.logDetail = record;
    this.logVisible = true;
  }
}
